import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientContractPage from "@/pages/client/ClientContractPage";

export const Route = createFileRoute("/client/contract")({
  head: () => pageHead("Client · Contract", "AKIVA client · contract portal.", "/client/contract", true),
  component: ClientContractPage,
});
